import { Gender } from '../models/participantRegistration';

export const getGenderDisplayName = (genderEnum: Gender | string | undefined): string => {
  if (!genderEnum) return 'Not available';

  if (typeof genderEnum === 'string' && ['Female', 'Male', 'Other'].includes(genderEnum)) {
    return genderEnum;
  }

  switch (genderEnum) {
    case Gender.F:
    case 'F':
      return 'Female';
    case Gender.M:
    case 'M':
      return 'Male';
    case Gender.O:
    case 'O':
      return 'Other';
    default:
      return 'Not available';
  }
};
